import { Button } from "@generalapplications/ui";

export type PageHeroCtaProps = {
  to: string;
  children: string;
};

// Route-level pages compose this product action instead of styling a primitive
// inline. The visual and accessibility contract remains with the component.
export function PageHeroCta({ to, children }: PageHeroCtaProps) {
  return (
    <Button href={to} size="xl" variant="outline">
      {children}
    </Button>
  );
}
